import(/* webpackMode: "eager", webpackExports: ["FuulReferralProvider"] */ "/vercel/path0/apps/web/src/app/(networks)/(evm)/_common/ui/fuul-referral-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarContainer"] */ "/vercel/path0/apps/web/src/app/(networks)/(evm)/_common/ui/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EdgeProvider"] */ "/vercel/path0/apps/web/src/providers/edge-config-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DerivedstateSimpleSwapProvider"] */ "/vercel/path0/apps/web/src/ui/swap/simple/derivedstate-simple-swap-provider.tsx");
